import { render, staticRenderFns } from "./AddBranchPopup.vue?vue&type=template&id=1d7efa1b"
import script from "./AddBranchPopup.vue?vue&type=script&lang=js"
export * from "./AddBranchPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports